export default __webpack_public_path__ + "a06ca0de8c5a1f67af211bc4f33d8d71.png";